import React from 'react'
import {
    validateEmail,
    validateName,
    validatePhone,
    validateMessage,
    containsSqlInjection,
    containsXss,
    containsCodeInjection,
} from '../../../../context-module/context-configuration/permission-provider/validation/index';

export const ValidationRuleCar = (name: string, value: string): string => { //NOSONAR
    // Check for injection attacks
    if (containsSqlInjection(value) || containsXss(value) || containsCodeInjection(value)) {
        return 'Input contains potentially dangerous content';
    }

    switch (name) {
        case 'fullName': {
            const result = validateName(value, 'Full name');
            return result.errors.length > 0 ? result.errors[0] : '';
        }
        case 'email': {
            const result = validateEmail(value);
            return result.errors.length > 0 ? result.errors[0] : '';
        }
        case 'phone': {
            if (value) {
                const result = validatePhone(value);
                return result.errors.length > 0 ? result.errors[0] : '';
            }
            return '';
        }
        case 'message': {
            if (value) {
                const result = validateMessage(value, 300);
                return result.errors.length > 0 ? result.errors[0] : '';
            }
            return '';
        }
        default:
            return '';
    }
};